module.exports = window.XMLHttpRequest;



/*****************
 ** WEBPACK FOOTER
 ** ./~/httpplease/lib/xhr-browser.js
 ** module id = 190
 ** module chunks = 0
 **/